import { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import MainContainer from '../../../components/ui_components/MainContainer';
import { useLoaderData, useNavigate } from 'react-router-dom';
import RenderButtonChangePageStats from '../../../components/MobileComponents/Stats/HomeStats/RenderButtonChangePageStats';
import colors from '../../../styles/colors';
import { LoadingState } from '../../../components/stats_components/LoadingState';
import { apiGetStats } from '../../../components/ui_components/ApiList';
import AltroButtonStatsMobile from '../../../components/MobileComponents/Stats/HomeStats/AltroButtonStatsMobile';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 30px 0;

    & .title-stats-mobile {
        margin: 0;
        padding: 0;
        letter-spacing: 2px;
        font-size: 25px;
        font-weight: 800;
        text-transform: uppercase;
        margin-bottom: 5px;
        color: white;
    }
`;

const RowButtonYearsSelecetion = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 10px 0;

    & .space-button-year {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        & .button-year, & .select-year {
            width: 75%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid white;
            border-radius: 5px;
            background-color: ${colors.bgColorBlack};
            color: white;
            font-size: 16px;
            font-weight: 600;
            text-transform: uppercase;
            text-align: center;

            &.selected {
                background-color: ${colors.bgColorBordeaux};
            }
        }
    }
`;

const ContainerButtons = styled.div`
    width: 100%;
    height: calc(100% - 50px);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 5px;
`;


function HomeStatsMobile() {
    const loaderData = useLoaderData() as any;
    const dataStatsGlobale = loaderData;
    const [dataStats, setDataStats] = useState(loaderData);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [isGlobaleSelected, setIsGlobaleSelected] = useState(true);
    const [isOpenSelectYear, setIsOpenSelectYear] = useState(false);

    // Genera gli anni dal 2005 all'anno corrente
    const currentYear = useMemo(() => new Date().getFullYear(), []);
    const years = useMemo(() => [...Array.from({ length: currentYear - 2004 }, (_, i) => currentYear - i)], [currentYear]);

    // Handle stat click
    const handleStatClick = (type) => {
        setIsLoading(true);
        navigate(`/stats/${type}`);
    };

    // Handle year change
    const handleYearChange = async (event) => {
        const year = parseInt(event.target.value);
        setIsLoading(true);
        setIsGlobaleSelected(false);
        setSelectedYear(year);

        try {
            const response = await apiGetStats(year);
            if (response.error) {
              console.error('Error in stats response:', response.error);
            } else {
                setDataStats(response);
            }
          } catch (error) {
            console.error('Error loading stats:', error);
          } finally {
            setIsLoading(false);
          }
    };

    // Handle isGlobaleButtonClick
    const handleIsGlobaleButtonClick = () => {
        setIsGlobaleSelected(true);
        setDataStats(dataStatsGlobale);
    };


    // isLoading
    if(isLoading) {
        return <LoadingState />;
    }

    return (
        <MainContainer isMobile={true} className='home-stats-mobile'>
            <Wrapper className='wrapper-stats-mobile'>
                <h2 className='title-stats-mobile'>Statistiche</h2>

                <RowButtonYearsSelecetion className='row-button-years-selecetion'>
                    <div className='space-button-year'>
                        <button 
                            className={`button-year ${isGlobaleSelected ? 'selected' : ''}`} 
                            onClick={() => handleIsGlobaleButtonClick()}
                        >
                            All Time
                        </button>
                    </div>
                    <div className='space-button-year'>
                        {/* // Button che al click apre la select  */}
                        <select 
                            className={`select-year ${!isGlobaleSelected ? 'selected' : ''}`} 
                            onChange={handleYearChange}
                        >
                            {years.map((year, index) => (
                                <option key={index} value={year} selected={year === selectedYear}>{year}</option>
                            ))}
                        </select>
                    </div>
                </RowButtonYearsSelecetion>

                <ContainerButtons className='container-buttons-stats-mobile'>
                    {/* Miglior Lottatore */}
                    {dataStats.bestWrestler && (
                        <RenderButtonChangePageStats
                            title='Miglior Lottatore' 
                            wrestler={dataStats.bestWrestler} 
                            onClick={() => handleStatClick('best-wrestler')} 
                        />
                    )}

                    {/* Lottatore con più Vittorie */}
                    {dataStats.mostWinsWrestler && (
                        <RenderButtonChangePageStats 
                            title='Lottatore con più Vittorie' 
                            wrestler={dataStats.mostWinsWrestler} 
                            onClick={() => handleStatClick('most-wins-wrestler')}
                        />
                    )}

                    {/* Lottatore con più Match */}
                    {dataStats.mostMatchesWrestler && (
                        <RenderButtonChangePageStats 
                            title='Lottatore con più Match' 
                            wrestler={dataStats.mostMatchesWrestler} 
                            onClick={() => handleStatClick('most-matches-wrestler')} 
                        />
                    )}

                    {/* Miglior Lottatrice */}
                    {dataStats.bestWrestlerWoman && (
                        <RenderButtonChangePageStats 
                            title='Miglior Lottatrice' 
                            wrestler={dataStats.bestWrestlerWoman} 
                            onClick={() => handleStatClick('best-wrestler-woman')} 
                        />
                    )}

                    {/* Lottatrice con più Vittorie */}
                    {dataStats.mostWinsWrestlerWoman && (
                        <RenderButtonChangePageStats 
                            title='Lottatrice con più Vittorie' 
                            wrestler={dataStats.mostWinsWrestlerWoman} 
                            onClick={() => handleStatClick('most-wins-wrestler-woman')}
                        />
                    )}

                    {/* Lottatrice con più Match */}
                    {dataStats.mostMatchesWrestlerWoman && (
                        <RenderButtonChangePageStats 
                            title='Lottatrice con più Match' 
                            wrestler={dataStats.mostMatchesWrestlerWoman} 
                            onClick={() => handleStatClick('most-matches-wrestler-woman')}
                        />
                    )}

                    {/* Stats Forum */}
                    <AltroButtonStatsMobile
                        title='Stats Forum'
                        onClick={() => handleStatClick('stats-forum')}
                    />
                </ContainerButtons>
            </Wrapper>
        </MainContainer>
    )
}

export default HomeStatsMobile;